export const services = [
  {
    id: 1,
    title: "Digital Content Marketing",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <g clipPath="url(#clip0_548_578)">
          <path
            d="M20 6.6665L17.65 9.0165L26.95 18.3332H6.66663V21.6665H26.95L17.65 30.9832L20 33.3332L33.3333 19.9998L20 6.6665Z"
            fill="#2193F7"
          />
        </g>
        <defs>
          <clipPath id="clip0_548_578">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    description:
      "Boost your brand’s online presence with a complete package that includes Social Media Management, tailored Content Creation, polished Video Editing, and dynamic Motion Graphics. We’ll help grow your audience, enhance engagement, and bring your brand story to life.",
    boldWords: [
      "Social Media Management",
      "Content Creation",
      "Video Editing",
      "Motion Graphics",
    ],
    link: "/creativeBundle",
  },
  {
    id: 2,
    title: "Creative Design",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <g clipPath="url(#clip0_548_578)">
          <path
            d="M20 6.6665L17.65 9.0165L26.95 18.3332H6.66663V21.6665H26.95L17.65 30.9832L20 33.3332L33.3333 19.9998L20 6.6665Z"
            fill="#2193F7"
          />
        </g>
        <defs>
          <clipPath id="clip0_548_578">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    description:
      "Elevate your brand with Graphic Design, Web Design, and UI/UX Design. Perfect for businesses and entrepreneurs, this package delivers captivating visuals and a seamless user experience to boost engagement and conversions.",
    boldWords: ["Graphic Design", "Web Design", "UI/UX Design"],
    link: "/creativeBundle",
  },

  {
    id: 3,
    title: "Paid Advertisement",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <g clipPath="url(#clip0_548_578)">
          <path
            d="M20 6.6665L17.65 9.0165L26.95 18.3332H6.66663V21.6665H26.95L17.65 30.9832L20 33.3332L33.3333 19.9998L20 6.6665Z"
            fill="#2193F7"
          />
        </g>
        <defs>
          <clipPath id="clip0_548_578">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    description:
      "Increase your online visibility with SEO & SEM strategies to attract targeted visitors through search engines. Enhance engagement and ROI with Paid Social Media Advertising on Social Media platforms to reach your ideal audience effectively.",
    boldWords: ["SEO & SEM", "Paid Social Media Advertising"],
    link: "/creativeBundle",
  },
];
